import { useTheme } from '@mui/material/styles';

export const BoardBuilderStyles = ({ groupEnabled }) => {
    const theme = useTheme();
    return {
        ...(groupEnabled && {
            maxHeight: '70vh',
            paddingBottom: '16px',
            maxWidth: '768px',
            overflowY: 'auto',
            width: '90vw',
            '& .fix-selection-switch': {
                width: '160px',
            },
            '& .fix-selection-switch label': {
                color: '#fff',
            },
            '& .comparison-group-field .MuiAutocomplete-tag': {
                color: '#fff',
            },
        }),
        "& .submit-button": {
            backgroundColor: theme.palette.purple.main,
            fontWeight: 'bold',
            marginTop: "10px",
            '&:hover': {
                backgroundColor: theme.palette.purple.light
            },
        }
    }
}
